module.exports = __webpack_public_path__ + "img/box-3-eng.43d4881b.png";